import page from './page';
import throttle from 'lodash/throttle';
import { getHeader } from "../helpers/header-utils";

const header = getHeader();
const heroMobileElement = () => document.querySelector('.cms-content-main > .cms-content-main__resp-wrapper > .col:nth-child(1)');
const heroMobileDividerElement = () => document.querySelector('.cms-content-main > .cms-content-main__resp-wrapper > .col:nth-child(1) .cms-divider-rsp');
const heroElement = () => document.querySelector('.cms-content-main > .cms-content-main__resp-wrapper > .col:nth-child(2)');
const heroDividerElement = () => document.querySelector('.cms-content-main > .cms-content-main__resp-wrapper > .col:nth-child(2) .cms-divider-rsp');
const dividerElement = () => document.querySelector('.cms-content-main > .cms-content-main__resp-wrapper > .col:nth-child(3)');
const transitionElement = () => document.querySelector('.cms-content-main > .cms-content-main__resp-wrapper > .col:nth-child(4) .cms-image-rsp__image');
const transitionContainerElement = () => document.querySelector('.cms-content-main > .cms-content-main__resp-wrapper > .col:nth-child(4) .cms-grid-container');
const transitionImageContainerElement = () => document.querySelector('.cms-content-main > .cms-content-main__resp-wrapper > .col:nth-child(4) .cms-image-container-rsp');
const allFullScreenImagesElements = () => document.querySelectorAll('.cms-content-main > .cms-content-main__resp-wrapper .cms-container-rsp--full-bleed .cms-image-rsp__image');

const getHeight = (elementFunction) => {
  const element = elementFunction();
  return element ? element.offsetHeight : 0;
};

const headerHeight = () => getHeight(header);
const heroHeight = () => getHeight(heroElement) + getHeight(heroMobileElement);
const heroDividerHeight = () => getHeight(heroDividerElement) + getHeight(heroMobileDividerElement);
const dividerHeight = () => getHeight(dividerElement);
const transitionHeight = () => getHeight(transitionElement);

const HeroContent = {
  init: () => {
    transitionContainerElement().style.overflow = 'visible';
    transitionImageContainerElement().style.overflow = 'visible';
    const transition = transitionElement();
    transition.style['transform-origin'] = 'center';
    transition.style.opacity = '0';
    transition.style.transition = 'opacity 1s ease, transform 0.1s linear';

    const images = allFullScreenImagesElements();

    images.forEach((imageElement, i) => {
      if (i > 1) {
        imageElement.style.visibility = 'hidden';
        const imgUrl = imageElement.src;
        const parentNode = imageElement.parentNode;
        parentNode.style.background = `url('${imgUrl}')`;
        parentNode.style['background-size'] = 'auto 100vh';
        parentNode.style['background-attachment'] = 'fixed';
        parentNode.style['background-repeat'] = 'no-repeat';
        parentNode.style['background-position'] = 'center center';
        imageElement.style.height = '100vh';
      }
    });


    setTimeout(() => {
      HeroContent.setTransition();
      transition.style.opacity = '1';
    }, 1100);
  },

  setTransition: () => {
    transitionElement().style.transform = `translateY(${HeroContent.getYTranslate()}px) scale(${HeroContent.getScale()})`;
  },

  getTotalTransition: () => heroHeight() * 0.75,
  getTotalTransitionLength: () => dividerHeight() + heroDividerHeight() + (heroHeight() - heroDividerHeight()) / 2 + transitionHeight() / 2,
  getYTranslate: () => -1 * HeroContent.getTotalTransitionLength() * HeroContent.getInvertedPercent(),
  getScale: () => HeroContent.getInvertedPercent() + 1,
  getInvertedPercent: () => {
    let moveY = window.scrollY >= headerHeight() ? window.scrollY : headerHeight();
    moveY = moveY >= HeroContent.getTotalTransition() + headerHeight() ? HeroContent.getTotalTransition() + headerHeight() : moveY;
    return (HeroContent.getTotalTransition() - (moveY - headerHeight())) / HeroContent.getTotalTransition()
  },

  addScrollListener: () => {
    window.addEventListener('scroll', throttle(HeroContent.setTransition, 100));
  }
};

page('.cms-container-rsp--hero-aem-contentpage-demo', () => {
  if (heroElement()) {
    HeroContent.init();
    HeroContent.addScrollListener();
  }
});
